import {
  AllCommunityModule,
  ModuleRegistry,
  RowSelectionModule,
} from 'ag-grid-community';

// Registered next to the components that render a grid, not at app boot: the grid is
// a megabyte of source and no screen on the way to the home page uses it.
ModuleRegistry.registerModules([AllCommunityModule, RowSelectionModule]);
